import { Button } from 'blaze-ui/Button'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { Check2 } from 'blaze-ui/icons'
import { ArrowUpRight } from 'blaze-ui/icons/16'
import { ReactComponent as SpecialOfferBanner } from 'assets/img/special-offer-50.svg'
import Styles from './SpecialOffer.module.scss'
import { Modal } from 'almanac-ui/Modal'

interface Props {
  onBack: () => void
  onContinueCancelling: () => void
  onAcceptOffer: () => void
  onClose: () => void
  isLoading: boolean
}

const SCHEDULE_TIME_URL = 'https://calendly.com/ashley-blaze/blaze-customer-check-in'

const benefits = [
  'Automatic content creation and scheduling every week',
  'Hands-free publishing across multiple platforms',
  'Simple, powerful insights that lead to growth',
  'Support from real humans, whenever you need it',
]

export const SpecialOffer = ({ onBack, onContinueCancelling, onAcceptOffer, onClose, isLoading }: Props) => {
  return (
    <div className={Styles.container}>
      <Modal.Header title="Special offer" onClose={onClose} />
      <div className={Styles.content}>
        <Heading level={2} color="var(--dark-80)">
          Wait! We have a special offer for you.
        </Heading>
        <div className={Styles.heroBanner}>
          <SpecialOfferBanner className={Styles.bannerImage} />
        </div>
        <div className={Styles.benefits}>
          <Heading level={5}>
            What you'll keep:
          </Heading>
          <ul className={Styles.benefitsList}>
            {benefits.map((benefit) => (
              <li key={benefit} className={Styles.benefitItem}>
                <span className={Styles.checkIcon}>
                  <Check2 size={14} color="white" />
                </span>
                <Text variant="primary" color="var(--dark-80)">
                  {benefit}
                </Text>
              </li>
            ))}
          </ul>
        </div>
        <div className={Styles.strategySession}>
          <Heading level={5}>
            Schedule a free 1:1 marketing strategy session with an expert:
          </Heading>
          <a
            href={SCHEDULE_TIME_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none', display: 'inline-block' }}
          >
            <Button
              variant="secondary"
              size="md"
              endIcon={ArrowUpRight}
            >
              Schedule Time
            </Button>
          </a>
        </div>
      </div>
      <div className={Styles.divider} />
      <div className={Styles.footer}>
        <Button className={Styles.backButton} variant="tertiary" size="lg" onPress={onBack} isDisabled={isLoading}>
          Back
        </Button>
        <div className={Styles.buttonGroup}>
          <Button variant="tertiary" size="lg" onPress={onContinueCancelling} isDisabled={isLoading}>
            No Thanks, Continue Canceling
          </Button>
          <Button variant="primary" size="lg" onPress={onAcceptOffer} isDisabled={isLoading}>
            Accept Offer
          </Button>
        </div>
      </div>
    </div>
  )
}
